import { CURRENT_SITE } from '../../config-sites';
import { URLS } from '../../config-urls';

/**
 * will transform links to hardcoded hosts (e.g. corporate.charter.com)
 * into relative links in the same environment.
 *
 * Allows the site to be swapped, too
 *
 * @param destinationUrl - Optional. A fully qualified base URL (e.g. https://stage-content.cew.ncs.spectrumflow.net)
 *   that will be prepended to relative paths. When provided, bypasses all host-matching logic.
 *   Used by MainMenuSubMenu to resolve cross-site links at build time without relying on window.
 */
export const processLink = (
    link: string,
    isPolicy: boolean,
    nodeLookup?: any,
    targetSite?: `cew` | `ga`,
    destinationUrl?: string
) => {
    const listToUse = isPolicy ? URLS.ga : URLS.cew;
    if (!link) return `#`;
    if (link.includes(`internal:`)) {
        link = link.replace(`internal:`, ``);
    }
    if (link === `/homepage` || link === `/home`) {
        link = `/`;
    }
    if (destinationUrl && link.startsWith(`/`)) {
        return `${destinationUrl}${link}`;
    }
    if (link.includes(`entity:node/`)) {
        const nodeId = link.split(`/`)[1];
        if (nodeLookup) {
            const matchingNode = nodeLookup.find(
                (node) =>
                    node.pageContext.drupal_internal__nid?.toString() === nodeId
            );
            if (matchingNode) {
                return matchingNode.pageContext.fields.url;
            }
        }
    }
    if (link.startsWith(`/`)) {
        if (targetSite) {
            for (const envName in listToUse) {
                if (typeof window !== `undefined`) {
                    if (listToUse[envName].includes(window.location.host)) {
                        return `${window.location.protocol}//${
                            URLS[targetSite][envName][
                                listToUse[envName].indexOf(window.location.host)
                            ]
                        }${link}`;
                    }
                }
            }
        } else {
            return link;
        }
    }
    try {
        const url = new URL(link);
        for (const envName in listToUse) {
            if (listToUse[envName].includes(url.host)) {
                if (!targetSite) {
                    return url.pathname;
                } else {
                    return URLS[targetSite][envName][
                        listToUse[envName].indexOf(url.host)
                    ];
                }
            }
        }

        return link;
    } catch {
        return link;
    }
};
